<template>
  <div>
    <div  class="slide-header">
      <h1 class="font-weight-bold" style="line-height: 1;font-size: 2.5rem;font-weight: 500">
        {{title}}
      </h1>
      <h4 style="font-size: 1.2rem;" :class="['mx-auto',$vuetify.breakpoint.mdAndDown?'w-80':'w-40']">
        {{subTitle}}
      </h4>
    </div>
    <div class="slide-box text-center d-flex justify-center">

      <v-row class="mx-0 px-0 pos-absolute">
        <v-col cols="12" xl="4" lg="4" md="4" v-for="item in list">
          <CatalogueItem v-if="type==='catalogue'" :item="item"/>
          <NewsItem v-else :item="item"/>

        </v-col>
      </v-row>
      <router-link
          :to="type==='catalogue'?'/catalogue':'/all-news'"
          class="load-more text-decoration-none"
      >
        {{$t('more')}}
      </router-link>

    </div>
  </div>
</template>

<script>
import NewsItem from "../../../components/news_item/NewsItem";
import CatalogueItem from "../../../components/news_item/CatalougeItem";
export default {
  name: "slider",
  components: {CatalogueItem, NewsItem},
  props:{
    list:[],
    title:String,
    subTitle:String,
    type:String
  },
}
</script>

<style scoped>

*, *:after, *:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
h5{
  font-size: 1.1rem;
  font-weight: bold;
}

@media screen and (max-width: 960px){
  .slide-box{
    display: table;
    background: rgba(0, 0, 0, 0.09);
    position: relative;
    margin: 0;
    width: 100%;
    height: 1500px;
    -webkit-clip-path: polygon(100% 0, 100% 98%, 0 100%, 0 0);
    clip-path: polygon(100% 0, 100% 98%, 0 100%, 0 0);
    padding-top: 16px;
  }
  .load-more {
    position: absolute;
    width: 60vw;
    margin: auto 20vw;
    bottom: 84px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #25458c;
    background: #FCC300;
  }
  h5{
    font-size: 16px;
  }
}
@media screen and (min-width: 960px){
  .slide-box{
    display: table;
    background: rgba(0, 0, 0, 0.09);
    position: relative;
    margin: 0;
    width: 100%;
    height: 500px;
    /*-webkit-clip-path: polygon(100% 0, 100% 88%, 0 100%, 0 0);*/
    /*clip-path: polygon(100% 0, 100% 88%, 0 100%, 0 0);*/
    padding-top: 16px;
  }
  .load-more {
    position: absolute;
    width: 20vw;
    margin: auto 40vw;
    bottom: 80px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #25458c;
    font-weight: bold;
    cursor: pointer;
    background: #FCC300;
  }
}


.slide-header{
  background: rgba(0, 0, 0, 0.09);
  width: 100vw;
  padding: 48px 0  0;
  text-align: center;
}

.pos-absolute {
  position: absolute;
  width: 94%;
  margin: 0 auto;

}


.load-more:hover{
  background: #25458c;
  color: #FCC300;
  transition: color 0.5s;
  transition: background-color 0.5s;
}


</style>